// extracted by mini-css-extract-plugin
export var fileUpload = "_gt-1";
export var modalButton = "_gt-0";